/**
 * #46: drug administration windows ("okno podania leku"). Per-trial list of
 * 1..5 windows, each with a name, a required minimum (days) and an optional
 * maximum. PL "Okno podania leku" / EN "Drug administration window".
 */
export type MedicationWindowLang = 'pl' | 'en';

export interface MedicationWindowMessages {
  dialogTitle: string;
  dialogSubtitle: string;
  addWindow: string;
  editWindow: string;
  deleteWindow: string;
  close: string;
  cancel: string;
  save: string;
  saving: string;
  deleting: string;
  name: string;
  namePlaceholder: string;
  nameRequired: string;
  minDays: string;
  minDaysRequired: string;
  minDaysInvalid: string;
  maxDays: string;
  maxDaysInvalid: string;
  maxDaysOptionalHint: string;
  noWindows: string;
  maxReached: string;
  unknownError: string;
}

const pl: MedicationWindowMessages = {
  dialogTitle: 'Okno podania leku',
  dialogSubtitle: 'Okna podania leku (1–5). Każde ma nazwę, minimum w dniach i opcjonalne maksimum.',
  addWindow: 'Dodaj okno',
  editWindow: 'Edytuj okno',
  deleteWindow: 'Usuń',
  close: 'Zamknij',
  cancel: 'Anuluj',
  save: 'Zapisz okno',
  saving: 'Zapisywanie…',
  deleting: 'Usuwanie…',
  name: 'Nazwa',
  namePlaceholder: 'np. Lek A 320 mg',
  nameRequired: 'Nazwa jest wymagana',
  minDays: 'Minimum (dni)',
  minDaysRequired: 'Minimum w dniach jest wymagane',
  minDaysInvalid: 'Podaj całkowitą liczbę dni (od 0)',
  maxDays: 'Maksimum (dni)',
  maxDaysInvalid: 'Podaj całkowitą liczbę dni (od 0) albo zostaw puste',
  maxDaysOptionalHint: 'Puste = tylko dolna granica',
  noWindows: 'Brak okien podania leku.',
  maxReached: 'Osiągnięto maksimum 5 okien',
  unknownError: 'Nie udało się zapisać okna podania leku.',
};

const en: MedicationWindowMessages = {
  dialogTitle: 'Drug administration window',
  dialogSubtitle: 'Drug administration windows (1–5). Each has a name, a minimum in days and an optional maximum.',
  addWindow: 'Add window',
  editWindow: 'Edit window',
  deleteWindow: 'Delete',
  close: 'Close',
  cancel: 'Cancel',
  save: 'Save window',
  saving: 'Saving…',
  deleting: 'Deleting…',
  name: 'Name',
  namePlaceholder: 'e.g. Drug A 320 mg',
  nameRequired: 'Name is required',
  minDays: 'Minimum (days)',
  minDaysRequired: 'Minimum in days is required',
  minDaysInvalid: 'Enter a whole day count (0 or more)',
  maxDays: 'Maximum (days)',
  maxDaysInvalid: 'Enter a whole day count (0 or more) or leave blank',
  maxDaysOptionalHint: 'Blank = lower bound only',
  noWindows: 'No drug administration windows.',
  maxReached: 'Maximum of 5 windows reached',
  unknownError: 'Could not save the drug administration window.',
};

export function medicationWindowTexts(lang: MedicationWindowLang): MedicationWindowMessages {
  return lang === 'en' ? en : pl;
}